import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {CaseDTO} from '../models/CaseDTO';
import {CaseFuneralDTO} from '../models/CaseFuneralDTO';

@Injectable({
  providedIn: 'root'
})
export class CaseFuneralService {
  private caseUrl = environment.baseClmUrl + '/case';
  private caseFuneralUrl = environment.baseClmUrl + '/case-funeral';

  constructor(private httpClient: HttpClient) {
  }

  getListOfFuneralCases(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<CaseDTO>> {
    return this.httpClient.post<PagedResponseDTO<CaseDTO>>(this.caseUrl + '/filter', pagedRequestDTO);
  }

  getCaseFuneralByCaseId(caseId: number): Observable<CaseFuneralDTO> {
    return this.httpClient.get<CaseFuneralDTO>(`${this.caseUrl}-funeral/byCaseId?caseId=${caseId}`);
  }

  deleteFuneralCase(caseId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.caseUrl + '/' + caseId);
  }

  saveCaseFuneral(caseFuneralPayload: CaseFuneralDTO): Observable<CaseFuneralDTO> {
    return this.httpClient.post<CaseFuneralDTO>(`${this.caseFuneralUrl}`, caseFuneralPayload);
  }

  saveCaseFuneralDocument(payload: CaseFuneralDTO): Observable<CaseFuneralDTO> {
    // Technical Dept: Needs to save complete CaseFuneral Payload
    return this.saveCaseFuneral(payload);
  }

}
